export const centrum = {
	color: '#00467F'
};

export const aktualne = {
	color: '#1B69BF'
};
